import { render, staticRenderFns } from "./AllocationLinearGraph.vue?vue&type=template&id=203d82f0&lang=pug"
import script from "./AllocationLinearGraph.vue?vue&type=script&lang=js"
export * from "./AllocationLinearGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports